import React from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

import { selectUserCredits } from "store/users/selectors";

import SelectAmount from "../../SelectAmount";
import NewBalance from "../../NewBalance";

import classes from "./styles.module.scss";

const Step1 = ({ userCredits = {}, amountToPurchase = 0, setAmountToPurchase = 0 }) => {
    const { total: legacyCredits = 0, credits: newCredits = 0 } = userCredits || {};

    return (
        <div className={classes.step1Container}>
            <p className={classes.step1Title}>Select number of credits</p>
            <SelectAmount amountToPurchase={amountToPurchase} setAmountToPurchase={setAmountToPurchase} />
            <NewBalance currentBalance={newCredits} toPurchase={amountToPurchase} />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    userCredits: selectUserCredits,
});

export default connect(mapStateToProps, null)(Step1);
